import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { isReducedMotionPreferred } from "../utils/accessibilityPrefs";

const ScrollToTop = () => {
  const { pathname, search, hash, key } = useLocation();
  const isInitialRender = useRef(true);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (isInitialRender.current) {
      isInitialRender.current = false;
      return undefined;
    }

    const behavior = isReducedMotionPreferred() ? "auto" : "smooth";

    // Hash navigation: scroll to the target element instead of the top.
    // Lazy-loaded pages render after the navigation, so retry until the
    // element exists.
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      let frame;
      let attempts = 0;
      const scrollToTarget = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior });
          return;
        }
        if (attempts < 120) {
          attempts += 1;
          frame = window.requestAnimationFrame(scrollToTarget);
        }
      };
      frame = window.requestAnimationFrame(scrollToTarget);
      return () => window.cancelAnimationFrame(frame);
    }

    const frame = window.requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior,
      });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, search, hash, key]);

  return null;
};

export default ScrollToTop;
